import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useToast } from 'components/Shared/AppToast/ToastProvider'
import { fetchPartnerBranding } from 'api/partner'
import BusinessNameField from './BusinessNameField'
import BusinessLogoField from './BusinessLogoField'

/**
 * Client-global Google Ads branding defaults (business name + logo).
 * Applied by the backend as a fallback wherever a creative doesn't set its own.
 * Figma: node 31504:25014, "Google business name - logo settings".
 */
const BrandingSettings = () => {
  const { t } = useTranslation()
  const { addNotification } = useToast()

  const [businessName, setBusinessName] = useState('')
  const [logoUrl, setLogoUrl] = useState('')
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    let cancelled = false
    ;(async () => {
      try {
        const branding = await fetchPartnerBranding()
        if (cancelled) return
        setBusinessName(branding.businessName)
        setLogoUrl(branding.logoUrl)
      } catch (error) {
        if (!cancelled) {
          addNotification({ message: t('Settings.branding.loadError'), variant: 'error' })
        }
      } finally {
        if (!cancelled) setIsLoading(false)
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    })()
    return () => {
      cancelled = true
    }
  }, [])

  return (
    <>
      <BusinessNameField initialValue={businessName} isLoading={isLoading} />
      <BusinessLogoField initialValue={logoUrl} isLoading={isLoading} />
    </>
  )
}

export default BrandingSettings
